import { render } from "./MAGMA.vue?vue&type=template&id=c354bd22&scoped=true"
import script from "./MAGMA.vue?vue&type=script&lang=js"
export * from "./MAGMA.vue?vue&type=script&lang=js"

import "./MAGMA.vue?vue&type=style&index=0&id=c354bd22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c354bd22"]])

export default __exports__